import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getAllUser } from 'services/user.service';
import { UserProfile } from 'types/auth';

interface UserState {
  data: any[];
  users: UserProfile[];
  loginDevices: any[];
  sortingData: any[];
  pageIndex: number;
  count: number;
  size: number;
  totalUsers: number;
  search: string;
  timeline: any[];
}

const initialState: UserState = {
  data: [],
  users: [],
  loginDevices: [],
  sortingData: [],
  pageIndex: 1,
  count: 0,
  size: 10,
  totalUsers: 0,
  search: '',
  timeline: []
};

// ✅ Async thunk (pass orgId from component)
export const getUsers = createAsyncThunk(
  'users/get',
  async (orgId: string) => {
    const response = await getAllUser({ orgId });
    return response.data.data;
  }
);

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    resetUserState: () => initialState,
    setTotalUsers: (state, action) => {
      state.totalUsers = action.payload;
    },
    updateUser: (state, action) => {
      state.data = action.payload;
    },
    setSortingValue: (state, action) => {
      state.sortingData = action.payload;
    },
    getUsersDetails: (state, action) => {
      state.users = action.payload;
    },
    setUserPageIndex: (state, action) => {
      state.pageIndex = action.payload;
    },
    setUserPageSearch: (state, action) => {
      state.search = action.payload;
    },
    setUserCount: (state, action) => {
      state.count = action.payload;
    },
    setUserTableSize: (state, action) => {
      state.size = action.payload;
    },
    removeUser: (state, action) => {
      state.users = state.users.filter((user: UserProfile) => user._id !== action.payload);
    },
    removeLoginDevice: (state, action) => {
      const deviceIdToRemove = action.payload;
      state.users = state.users.map((user: any) => ({
        ...user,
        loginDevices: user.loginDevices?.filter(
          (device: any) => device._id !== deviceIdToRemove
        ) || []
      }));
    },
    getTimeLine: (state, action) => {
      state.timeline = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getUsers.fulfilled, (state, action) => {
      state.data = action.payload;
    });
  }
});

export const {
  resetUserState,
  setTotalUsers,
  updateUser,
  setSortingValue,
  getUsersDetails,
  setUserPageIndex,
  setUserPageSearch,
  setUserCount,
  setUserTableSize,
  removeUser,
  removeLoginDevice,
  getTimeLine
} = usersSlice.actions;

export default usersSlice.reducer;
